import { Component, OnInit, Input } from '@angular/core';
import * as echarts from 'echarts';
import { FormsModule, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from "../../services/auth.service";
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HomeService } from '../../services/home.service';
import { AlertComponent } from '../alert/alert.component';
import { CommonEncrypt } from '../../utils/common.encrypt';
import { StudyBase } from '../common/study-base';
import { empty, interval } from 'rxjs';
import { AppendComponent } from '../append/append.component';
import { ModalComponent } from '../modal/modal.component';
import { ActivatedRoute } from "@angular/router"
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfig } from '../../app.config';
import { GlobalVariable } from '../../app.globalvariable';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})



export class HomeComponent implements OnInit {
  constructor(private sanitizer: DomSanitizer, private auth: AuthService,
    public router: Router, public route: ActivatedRoute,
    public service: HomeService,
    public modalService: BsModalService) {
    this.auth.random();

    this.route.params.subscribe(params => {
      if(params['id']){
        this.pages = 'home/'+params['id']
        // console.log(params['id'],this.pages)
      }else{
        this.pages = "home/home"
        // console.log(params['id'],this.pages)
      }
    });

  }
  tab = '1';
  pages:string = "home/home";
  navName:string = '';
  navShow:boolean = false


  // tabIndex(x){
  //   this.tab = x
  // }

  goDetails(x,n){
    this.pages = 'home/'+x;
    this.navName = n;
    console.log(x,n)
    window.scrollTo(0, 0);
    this.navShow = false
  }

  showNav(){
    this.navShow = true
  }
  hideNav(){
    this.navShow = false
  }

  ngOnInit() {
    
  }







}

